import { Link } from 'react-router-dom';

import { Share16 } from '@ingrid/iconography/react';
import { Button, ListLayout } from '@ingrid/luterkort-react';

import { CopyButton } from '~src/components/CopyButton/CopyButton';
import { useTranslation } from '~src/i18n/use-translation';

// @todo: consider switching to styled components instead of css modules
import styles from './EntityReference.module.css';

interface Props {
  value?: string;
  href?: string;
  label: string;
}

export function EntityReference({ value, label, href }: Props) {
  const { t } = useTranslation();

  return (
    <ListLayout.Row className={value && styles.entityReference}>
      <ListLayout.Stack>
        <ListLayout.SecondaryText>{label}</ListLayout.SecondaryText>
        <ListLayout.PrimaryText>{value ?? '-'}</ListLayout.PrimaryText>
      </ListLayout.Stack>

      {value && (
        <ListLayout.Actions className={styles.actions}>
          <CopyButton value={value} />

          {href && (
            <Button as={Link} to={href} variant="tertiary" size="sm">
              <Share16 />
              {t('common.showDetails')}
            </Button>
          )}
        </ListLayout.Actions>
      )}
    </ListLayout.Row>
  );
}
